/** @type {string} */
const toastComponent = "Toast";
export default toastComponent;
